module.exports = __webpack_public_path__ + "img/1_full.6cc302e4.jpg";